// src/styles/cursors.js

// Default cursor (pink dot)
export const CURSOR_DEFAULT = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Ccircle cx='6' cy='6' r='5' fill='%23ff3399'/%3E%3C/svg%3E"), auto`;

// Interactive cursor (pink circle/dot hover)
// Note: Added !important back as it was likely needed in GlobalStyle
export const CURSOR_INTERACTIVE = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E%3Ccircle cx='8' cy='8' r='7' stroke='%23ff3399' stroke-width='1.5' fill='none'/%3E%3Ccircle cx='8' cy='8' r='3' fill='%23ff3399'/%3E%3C/svg%3E"), auto !important`;

// Text input cursor (pink crosshairs)
// Note: Added !important back
export const CURSOR_TEXT = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'%3E%3Cpath d='M2,7 L12,7 M7,2 L7,12' stroke='%23ff3399' stroke-width='1.5'/%3E%3C/svg%3E"), text !important`;

// Disabled cursor (grey circle/line)
// Note: Added !important back
export const CURSOR_DISABLED = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'%3E%3Ccircle cx='7' cy='7' r='6' stroke='%23666666' stroke-width='1.5' fill='none'/%3E%3Cline x1='3' y1='7' x2='11' y2='7' stroke='%23666666' stroke-width='1.5'/%3E%3C/svg%3E"), not-allowed !important`;

// You can add other cursors here if needed (e.g., loading, grabbing)